// src/components/editor/useEditorWithDragDrop.js
import { useEffect } from 'react';
import { useEditor } from '@tiptap/react';

export default function useEditorWithDragDrop(extensions, initialContent = '') {
  const editor = useEditor({
    extensions,
    content: initialContent,
  });

  useEffect(() => {
    if (!editor || editor.isDestroyed || !editor.view?.dom) return;

    const handleDrop = (event) => {
      event.preventDefault();
      const file = event.dataTransfer.files?.[0];
      if (!file || !file.type.startsWith('image/')) return;

      const reader = new FileReader();
      reader.onload = () => {
        const base64 = reader.result;
        editor.chain().focus().insertContent({
          type: 'resizableImage',
          attrs: {
            src: base64,
            width: 'auto',
            height: 'auto',
            alt: '',
          },
        }).run();
      };
      reader.readAsDataURL(file);
    };

    const dom = editor.view.dom;
    dom.addEventListener('drop', handleDrop);
    dom.addEventListener('dragover', (e) => e.preventDefault());

    return () => {
      dom.removeEventListener('drop', handleDrop);
      dom.removeEventListener('dragover', (e) => e.preventDefault());
    };
  }, [editor]);

  return editor;
}